import React, { useState } from "react";
import { View, TouchableOpacity, Text, StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import { useDevice } from "./../_layout";
import Colors from "../../Resources/Color";

const MultipleSegmentedPicker = ({
  options,
  value,
  onChange,
  small = false,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handlePress = (index) => {
    onChange(index);
  };

  return (
    <View style={styles.containerPicker}>
      <View style={styles.segmentedControl}>
        {options.map((option, index) => {
          const selected = index === value;
          return (
            <TouchableOpacity
              key={option}
              style={[
                styles.segment,
                selected && styles.segmentSelected,
                {
                  paddingVertical: small ? 4 : 6,
                  paddingHorizontal: small ? 11 : 16,
                },
              ]}
              onPress={() => handlePress(index)}
              onMouseEnter={() => !isMobile && setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <Text
                style={[
                  styles.text,
                  selected ? styles.textSelected : null,
                  hoveredIndex === index ? styles.textHovered : null,
                  { fontSize: small ? 13 : 14 },
                ]}
              >
                {t(option)}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerPicker: {
    backgroundColor: Colors.backgroundColor,
    borderRadius: 15,
    paddingVertical: 4,
    paddingHorizontal: 2,

    alignSelf: "flex-start",
  },
  segmentedControl: {
    flexDirection: "row",
    alignSelf: "flex-start",
  },
  segment: {
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 2,
    borderRadius: 12,
  },
  segmentSelected: {
    backgroundColor: "rgba(63,123,141,0.9)",
    borderColor: "rgba(63,123,141,0.9)",
  },
  text: {
    color: Colors.grayColor,
  },
  textSelected: {
    color: Colors.whiteColor,
  },
  textHovered: {
    fontWeight: "600",
  },
});

export default MultipleSegmentedPicker;
